
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    Modal: () => import("@/components/Modal.vue"),
    ExportButton: () => import("@/components/ExportButton.vue"),
    RejectRequestModal: () => import("@/components/admin/RejectRequestModal.vue")
  },
  computed: {
    years() {
      let years: any = [];
      for (let i: number = new Date().getFullYear(); i >= 2000; i--) {
        years.push(i);
      }
      return years;
    }
  },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    }
  },
  watch: {
    $route(to, from) {
      (this as any).init();
    },
  },
})
export default class Requests extends Vue {
[x: string]: any;
  exportApiUrl: string = "requests/exportxls";
  adminRoles: any = [];
  dictionary: any = {};
  title: string = "";
  filter: any = {
    models: "companies,batches",
    businessId: "",
    companyId: "",
    controlZoneId: "",
    month: "",
    year: "",
    reporttype: "",
    branchId: "",
    trimester: "",
    status: "",
    code: "",
    requestNumber: "",
    seguredName: "",
    modifyType: -1,
    massiveUploadId: "",
    batchStateId: ""
  };
  currentRequest: number = 0;
  requests: any = [];
  requestsIds: number[] = [];
  selectedRequests: any = [];
  businesses: any = [];
  companies: any = [];
  controlzones: any = [];
  branches: any = [];
  massiveUploads: any = [];
  batchesStates: any = [];
  months: any = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Augosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  statuses: any = [];
  trimesters: any = [];
  limit: number = 5;
  totalRows: number = 0;
  isMassiveUpload: any = false;
  isGenerateBatch: any = false;
  checkbox: any = {
    visible: false,
    allSelected: true
  };
  sortColumns: Record<string, string> = {
    name: "Contrato",
    owner: "Responsable",
    deletedAt: "Estado"
  };
  currentSort: Record<string, string> = {
    col: "requests.order",
    dir: "asc"
  };

  async mounted() {
    await this.loadDictionary();
    await this.loadBusinesses();
    await this.loadCompanies();
    await this.loadBranches();
    await this.init();
  }

  async init() {
    if (this.$route.name === "admin-endorsments-without-movement") {
      this.filter.modifyType = 1;
      this.title = "Endosos sin movimientos";
    } else if (this.$route.name === "admin-endorsments-with-movement") {
      this.filter.modifyType = 2;
      this.title = "Endosos con movimientos";
    } else {
      this.filter.modifyType = -1;
      this.title = "Solicitudes";
    }
    this.loadMassiveUploads();
    this.loadControlZones();
    this.loadTrimesters();
    this.loadStatuses();
    this.loadBatchesStates();
    this.loadRequests(1, this.currentSort);
  }

  showDeleteModal(id: number) {
    this.currentRequest = id;
    (this.$refs.rejectModal as any).show();
  }

  async deleteRequest(rejectionReasonId: number, comment: string) {
    try {
      let response: any = await (this.$root as any)._delete(
        `requests/${this.currentRequest}`,
        { rejectionReasonId, comment }
      );
      this.loadRequests(1, this.currentSort);
      (this.$refs.rejectModal as any).hide();
      (this.$root as any).notify("Se elimino la solicitud con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo eliminar la solicitud.", "error");
    }
  }

  async exportRequests() {
    try {
      const response: any = await (this.$root as any)._post(
        "requests/exportxls",
        {
          ...this.filter
        }
      );

      window.open(response.path);
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo exportar, intente más tarde.",
        "error"
      );
    }
  }

  clearFilters() {
    Object.keys(this.filter).forEach((key: any) => {
      if (key !== "models") {
        if (key === "modifyType") this.filter[key] = -1;
        else this.filter[key] = "";
      }
    });
    this.loadRequests(1, this.currentSort);
  }

  statusClass(status) {
    if (status === 0 || status === 1) return "active";
    if (status === 5) return "pending";
    return "inactive";
  }

  onPageChange(page: number, limit: number) {
    this.limit = limit;
    this.loadRequests(page, this.currentSort, true);
  }

  async loadRequests(
    page: number,
    sort: Record<string, string>,
    pageChange: Boolean = false
  ) {
    this.currentSort = sort;

    const response: any = await (this.$root as any)._post("requests/all", {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      ...this.filter
    });

    this.prepareRequests(response.data, pageChange);

    this.totalRows = response.totalRows;
  }

  async prepareRequests(data: any[], isPageChange: Boolean) {

    let isBatchUnassigned = this.filter.batchStateId === "-1";
    let isCompanyFiltered = this.filter.companyId !== "";

    if (isBatchUnassigned && !isCompanyFiltered) {
      (this.$root as any).notify(
        "Recuerde que para generar un nuevo batch debe filtrar por contrato.",
        "warn"
      );
    }

    let isMassiveUpload = this.filter.massiveUploadId !== "";
    let isGenerateBatch = isCompanyFiltered && isBatchUnassigned;

    if (isMassiveUpload || isGenerateBatch) {
      if (!isPageChange) {
        let idsFilter = isMassiveUpload
          ? {
              ...this.filter,
              notStatus: this.statuses.indexOf("Procesada")
            }
          : this.filter;

        const requestsIds: any = await (this.$root as any)._post(
          "requests/ids",
          {
            order: this.currentSort,
            ...idsFilter
          }
        );

        this.checkbox = {
          visible: true,
          allSelected: true
        };

        this.isMassiveUpload = isMassiveUpload;
        this.isGenerateBatch = isGenerateBatch;

        this.requestsIds = requestsIds.data;
        this.selectedRequests = requestsIds.data;
      }

      this.requests = data.map((request: any) => ({
        ...request,
        selected: this.selectedRequests.includes(request.id)
      }));
    } else {
      this.checkbox = {
        visible: false,
        allSelected: true
      };

      this.isMassiveUpload = false;
      this.isGenerateBatch = false;

      this.requests = data;
    }
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  async loadBusinesses() {
    const response: any = await (this.$root as any)._post("businesses/all");
    this.businesses = response.data;
  }

  async loadCompanies() {
    const response: any = await (this.$root as any)._post("companies/all", {
      businessId: this.filter.businessId,
      businessFilter: this.filter.businessId != ""
    });

    this.companies = response.data;
  }

  async loadControlZones() {
    const response: any = await (this.$root as any)._post("controlzones/all");
    this.controlzones = response.data;
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get("branches");
    this.branches = response.data;
  }

  async loadTrimesters() {
    const response: any = await (this.$root as any)._get("requests/trimesters");
    this.trimesters = response;
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }

  async loadMassiveUploads() {
    const response: any = await (this.$root as any)._post(`massiveUploads`, {
      status: 2,
      companyId: this.filter.companyId,
      order: {
        col: "title",
        dir: "asc"
      }
    });

    this.massiveUploads = response.data.map(massiveUpload => {
      massiveUpload.createdAt = moment(massiveUpload.createdAt).format("LLL");
      return massiveUpload;
    });
  }

  async loadBatchesStates() {
    const response: any = await (this.$root as any)._get(`batches/states`);
    this.batchesStates = response.data;
  }

  // Massive upload feature functions 

  validateApprove() {
    if (this.selectedRequests.length !== 0) {
      (this.$refs.alertMassiveApprove as any).show();
    } else {
      (this.$root as any).notify("No ha seleccionado ninguna solicitud para procesar. Seleccione al menos una para continuar.", "error");
    }
  }

  validateBatchCreation() {
    if (this.selectedRequests.length !== 0) {
      (this.$refs.alertBatch as any).show();
    } else {
      (this.$root as any).notify("No ha seleccionado ninguna solicitud para generar un batch. Seleccione al menos una para continuar.", "error");
    }
  }

  async approveSelectedRequests() {
    try {
      const response: any = await (this.$root as any)._post(
        `requests/status/${this.statuses.indexOf("Procesada")}`,
        {
          requestsId: this.selectedRequests
        }
      );
      (this.$refs.alertMassiveApprove as any).hide();
      (this.$refs.successApprove as any).show();
      this.loadRequests(1, this.currentSort)
    } catch (e) {
      (this.$root as any).notify("No fue posible procesar las solicitudes.", "error");
    }
  }

  async generateBatch() {
    try {
      (this.$refs.alertBatch as any).hide();
      (this.$refs.processingBatch as any).show();

      await (this.$root as any)._post(`batches/requests`, {
        requestsId: this.selectedRequests
      });

      (this.$refs.processingBatch as any).hide();
      (this.$refs.successBatch as any).show();
      this.loadRequests(1, this.currentSort);
    } catch (e) {
      (this.$refs.processingBatch as any).hide();
      (this.$root as any).notify(e.message, "error");
    }
  }

  toggleSelectAll() {
    let allSelected = this.checkbox.allSelected

    this.selectedRequests = allSelected ? [] : this.requestsIds

    this.checkbox.allSelected = !allSelected

    this.requests = this.requests.map((request: any) => ({
      ...request,
      selected: !allSelected
    }));
  }

  toggleSelect(request: any) {
    let isSelected = this.selectedRequests.includes(request.id);

    if (isSelected) {
      this.selectedRequests = this.selectedRequests.filter(
        (id: number) => id !== request.id
      );
    } else {
      this.selectedRequests.push(request.id);
    }

    request.selected = !isSelected
    this.isAllSelected();
  }

  isAllSelected() {
    this.checkbox.allSelected = this.requestsIds.length === this.selectedRequests.length
  }
}
